import { jwtDecode } from 'jwt-decode';

export const safeJwtDecode = (token) => {
  // Enhanced validation for logout scenarios
  if (
    !token ||
    typeof token !== 'string' ||
    token === 'null' ||
    token === 'undefined' ||
    token.trim() === '' ||
    token === 'false'
  ) {
    return null;
  }

  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    // Additional check for each part
    if (!parts[0] || !parts[1] || !parts[2]) {
      return null;
    }

    return jwtDecode(token);
  } catch (error) {
    // Silent fail during logout to prevent console spam
    return null;
  }
};

export const getUserIdFromToken = (token) => {
  const decoded = safeJwtDecode(token);
  return decoded?.id || null;
};
